.mainCategory {
  margin: 24px 16px 0;
}

.rowHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.title,
.productCount {
  height: 18px;
  min-width: 124px;
  max-width: 124px;
}

.title {
  margin-bottom: 8px;
}

@media all and (--reefer-media-tablet-min) {
  .mainCategory {
    margin: 0 64px;
  }

  .rowHeader {
    margin-top: 10px;
  }

  .title {
    height: 32px;
  }

  .productCount {
    height: 24px;
  }
}
